'use client';

import { useTranslations } from 'next-intl';

function PausedIcon({ className }: { className?: string }) {
  return (
    <svg
      width="52"
      height="52"
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M17.8923 42.7895C14.8822 42.7895 13.2277 42.7895 12.0281 41.5944C10.833 40.3993 10.833 38.7404 10.833 35.7303V17.8926C10.833 14.8825 10.833 13.228 12.0281 12.0284C13.2233 10.8333 14.8822 10.8333 17.8923 10.8333C20.9024 10.8333 22.5568 10.8333 23.7564 12.0284C24.9515 13.2236 24.9515 14.8825 24.9515 17.8926V35.7303C24.9515 38.7404 24.9515 40.3948 23.7564 41.5944C22.5568 42.7895 20.9024 42.7895 17.8923 42.7895ZM17.8923 13.063C15.2969 13.063 14.1285 13.0853 13.6068 13.6071C13.085 14.1288 13.0627 15.2972 13.0627 17.8926V35.7303C13.0627 38.3256 13.085 39.494 13.6068 40.0158C14.1285 40.5375 15.2969 40.5598 17.8923 40.5598C20.4877 40.5598 21.656 40.5375 22.1778 40.0158C22.6995 39.494 22.7218 38.3256 22.7218 35.7303V17.8926C22.7218 15.2972 22.6995 14.1288 22.1778 13.6071C21.656 13.0853 20.4877 13.063 17.8923 13.063ZM35.73 42.7895C32.7199 42.7895 31.0654 42.7895 29.8658 41.5944C28.6662 40.3993 28.6707 38.7404 28.6707 35.7303V17.8926C28.6707 14.8825 28.6707 13.228 29.8658 12.0284C31.0609 10.8333 32.7199 10.8333 35.73 10.8333C38.7401 10.8333 40.3945 10.8333 41.5941 12.0284C42.7892 13.2236 42.7892 14.8825 42.7892 17.8926V35.7303C42.7892 38.7404 42.7892 40.3948 41.5941 41.5944C40.399 42.794 38.7401 42.7895 35.73 42.7895ZM35.73 13.063C33.1346 13.063 31.9662 13.0853 31.4445 13.6071C30.9227 14.1288 30.9004 15.2972 30.9004 17.8926V35.7303C30.9004 38.3256 30.9227 39.494 31.4445 40.0158C31.9662 40.5375 33.1346 40.5598 35.73 40.5598C38.3253 40.5598 39.4937 40.5375 40.0155 40.0158C40.5372 39.494 40.5595 38.3256 40.5595 35.7303V17.8926C40.5595 15.2972 40.5372 14.1288 40.0155 13.6071C39.4937 13.0853 38.3253 13.063 35.73 13.063Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function EventPausedCard() {
  const t = useTranslations('event.paused');

  return (
    <div className="flex flex-col items-center justify-center gap-4 rounded-[16px] bg-v2-surface-secondary p-6 shadow-v2-card">
      <PausedIcon className="text-v2-text-secondary" />
      <span className="text-center text-[24px] font-medium leading-8 text-v2-text-primary">
        {t('title')}
      </span>
    </div>
  );
}
